import { Grid, IconButton, Tooltip } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import { FraudTypeActionsProps } from './props';
import { useFraudTypeListActions } from './hook';

export const FraudTypeListActions = ({ id }: FraudTypeActionsProps) => {
    const { handleEdit } = useFraudTypeListActions(id);

    return (
        <Grid textAlign="left" width="100%">
            <Tooltip title="Editar">
                <IconButton size="small" onClick={handleEdit}>
                    <EditIcon type="submit" sx={{ color: 'primary.main' }} />
                </IconButton>
            </Tooltip>
        </Grid>
    );
};
